const options = [
  {
    title: <>What is the Data Science Club?</>,
    body: (
      <>
        The Data Science Club is a student-led organization focused on machine
        learning, analytics, data engineering, AI, and real-world tech
        applications.
      </>
    ),
  },
  {
    title: <>Who can participate in the event?</>,
    body: (
      <>
        The event is open to all students of our college from any branch and
        year. Beginners are welcome.
      </>
    ),
  },
  {
    title: <>I am unable to open the registration form. What should I do?</>,
    body: (
      <>
        <p>Try the following:</p>

        <p>- Clear your browser cache</p>
        <p>- Try a different browser (Chrome/Firefox recommended)</p>
        <p>- Check your internet connection</p>

        <p>
          If it still doesn’t work, contact us via the support form or our
          email.
        </p>
      </>
    ),
  },
  {
    title: <>The registration page is loading slow.</>,
    body: (
      <>
        <p>Possible reasons:</p>

        <p>- High traffic on the server</p>
        <p>- Slow internet</p>

        <p>Try refreshing the page or accessing it after a few minutes.</p>
      </>
    ),
  },
  {
    title: (
      <> I made a mistake in the registration form. How can I correct it?</>
    ),
    body: (
      <>
        <p>You may:</p>

        <p>- Submit the form again</p>
        <p>
          - Contact support requesting an edit, mentioning your name and
          registered mobile/email.
        </p>
      </>
    ),
  },
  {
    title: <> Payment was deducted but registration is not confirmed.</>,
    body: (
      <>
        <p>If applicable:</p>

        <p>- Take a screenshot of the payment confirmation</p>
        <p>- Email the support team with details</p>
        <p>We will verify and confirm your registration.</p>
      </>
    ),
  },
  {
    title: <> The website is not displaying correctly on my phone.</>,
    body: (
      <>
        <p>Try:</p>

        <p>- Refreshing the page</p>
        <p>- Clearing mobile browser cache</p>
        <p>- Opening the desktop version</p>

        <p>
          If the issue continues, take a screenshot and share it with support.
        </p>
      </>
    ),
  },
  {
    title: <>Where can I ask doubts before the event?</>,
    body: (
      <>
        <p>You can:</p>

        <p>- Contact the student coordinator</p>
        <p>Links are available on the event page.</p>
      </>
    ),
  },
];

export default options;
